document.addEventListener('DOMContentLoaded', () => {
  const modal = document.querySelector('[data-localization-modal]');
  if (!modal) return;

  const countryInput = document.getElementById('LocalizationModalCountryCode');
  const currencyInput = document.getElementById('LocalizationModalCurrencyCode');
  const langInput = document.getElementById('LocalizationModalLanguageCode');
  const countryDisplay = modal.querySelector('[data-selected-country-text]');
  const langDisplay = modal.querySelector('[data-selected-lang-text]');
  const form = document.getElementById('LocalizationModalForm');

  const SESSION_STORAGE_KEY = 'hmns_localization_seen';

  // Open & Close Functions
  const openModal = () => {
    modal.style.display = 'flex';
    // Force reflow for smooth animation
    modal.offsetHeight;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    sessionStorage.setItem(SESSION_STORAGE_KEY, 'true');
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    setTimeout(() => {
      if (!modal.classList.contains('is-open')) {
        modal.style.display = 'none';
      }
    }, 350);
  };

  // Auto Open Logic:
  // 1. If not seen yet in this session AND cookies already consented previously -> open
  // 2. If cookies banner is still visible -> wait until user clicks Accept / Reject, then open if not seen in session
  const cookieConsent = localStorage.getItem('hmns_cookie_consent');
  const alreadySeenInSession = sessionStorage.getItem(SESSION_STORAGE_KEY);

  if (!alreadySeenInSession) {
    if (cookieConsent) {
      setTimeout(openModal, 400);
    }
  }

  // Listen to cookie consent event
  window.addEventListener('cookie-consent:completed', () => {
    if (!sessionStorage.getItem(SESSION_STORAGE_KEY)) {
      setTimeout(openModal, 300);
    }
  });

  // Close triggers
  modal.querySelectorAll('[data-modal-close]').forEach((btn) => {
    btn.addEventListener('click', () => {
      closeModal();
    });
  });

  // ESC key to close
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) {
      closeModal();
    }
  });

  // Custom Select Dropdowns inside Modal
  const customSelects = modal.querySelectorAll('[data-custom-select]');
  customSelects.forEach((select) => {
    const trigger = select.querySelector('[data-select-trigger]');
    if (!trigger) return;

    trigger.addEventListener('click', (e) => {
      e.stopPropagation();
      // Close other open selects
      customSelects.forEach((other) => {
        if (other !== select) other.classList.remove('is-active');
      });
      select.classList.toggle('is-active');
      trigger.setAttribute('aria-expanded', select.classList.contains('is-active'));
    });
  });

  // Close custom select dropdowns when clicking outside
  document.addEventListener('click', (e) => {
    customSelects.forEach((select) => {
      if (!select.contains(e.target)) {
        select.classList.remove('is-active');
        const trigger = select.querySelector('[data-select-trigger]');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      }
    });
  });

  // Handle Country selection
  modal.querySelectorAll('[data-country-code]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      const code = btn.getAttribute('data-country-code');
      const currency = btn.getAttribute('data-currency-code');
      const name = btn.getAttribute('data-country-name');
      const flagEl = btn.querySelector('.localization-modal__flag');

      if (countryInput) countryInput.value = code;
      if (currencyInput && currency) currencyInput.value = currency;
      if (countryDisplay) {
        countryDisplay.innerHTML = (flagEl ? flagEl.outerHTML : '') + '<span>' + name + '</span>';
      }

      modal.querySelectorAll('[data-country-code]').forEach((b) => b.classList.remove('is-active'));
      btn.classList.add('is-active');

      const parentSelect = btn.closest('[data-custom-select]');
      if (parentSelect) parentSelect.classList.remove('is-active');
    });
  });

  // Handle Language selection
  modal.querySelectorAll('[data-lang-code]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      const code = btn.getAttribute('data-lang-code');
      const name = btn.getAttribute('data-lang-name');

      if (langInput) langInput.value = code;
      if (langDisplay) langDisplay.textContent = name;

      modal.querySelectorAll('[data-lang-code]').forEach((b) => b.classList.remove('is-active'));
      btn.classList.add('is-active');

      const parentSelect = btn.closest('[data-custom-select]');
      if (parentSelect) parentSelect.classList.remove('is-active');
    });
  });

  // Submit Handler
  if (form) {
    form.addEventListener('submit', (e) => {
      sessionStorage.setItem(SESSION_STORAGE_KEY, 'true');

      const selectedLang = langInput ? langInput.value : '';
      const selectedCountry = countryInput ? countryInput.value : '';

      // Dapatkan nama/teks negara yang dipilih dari button yang aktif atau countryDisplay
      const activeCountryBtn = modal.querySelector('[data-country-code].is-active');
      const countryText = activeCountryBtn
        ? (activeCountryBtn.getAttribute('data-country-name') || activeCountryBtn.textContent || '')
        : (countryDisplay ? countryDisplay.textContent : '');

      // Dapatkan currency dari currencyInput, atribut button, atau nama/kode negara
      let selectedCurrency = 'USD';
      if (activeCountryBtn && activeCountryBtn.getAttribute('data-currency-code')) {
        selectedCurrency = activeCountryBtn.getAttribute('data-currency-code').toUpperCase();
      } else {
        const textLower = (countryText || '').toLowerCase();
        if (textLower.includes('malaysia') || selectedCountry === 'MY') {
          selectedCurrency = 'MYR';
        } else if (textLower.includes('singapore') || selectedCountry === 'SG') {
          selectedCurrency = 'SGD';
        } else if (textLower.includes('indonesia') || selectedCountry === 'ID') {
          selectedCurrency = 'IDR';
        } else {
          selectedCurrency = 'USD';
        }
      }

      // Safety check: pastikan Malaysia selalu MYR, Singapore selalu SGD, Indonesia selalu IDR
      const checkText = (countryText || '').toLowerCase();
      if (checkText.includes('malaysia') || selectedCountry === 'MY') {
        selectedCurrency = 'MYR';
      } else if (checkText.includes('singapore') || selectedCountry === 'SG') {
        selectedCurrency = 'SGD';
      } else if (checkText.includes('indonesia') || selectedCountry === 'ID') {
        selectedCurrency = 'IDR';
      }

      // Pastikan hidden input terisi sesuai pilihan user sebelum disubmit ke Shopify
      if (countryInput) countryInput.value = selectedCountry;
      if (currencyInput) currencyInput.value = selectedCurrency;
      if (langInput) langInput.value = selectedLang;

      // 1. Simpan/trigger Bucks currency converter app
      if (typeof setBucksCurrency === 'function') {
        setBucksCurrency(selectedCurrency);
      }

      // 2. Tambahkan input return_to agar Shopify mengarahkan balik dengan parameter ?currency=
      let returnToInput = form.querySelector('input[name="return_to"]');
      if (!returnToInput) {
        returnToInput = document.createElement('input');
        returnToInput.type = 'hidden';
        returnToInput.name = 'return_to';
        form.appendChild(returnToInput);
      }

      const targetUrl = new URL(window.location.href);
      targetUrl.searchParams.set('currency', selectedCurrency);
      returnToInput.value = targetUrl.pathname + targetUrl.search;

      closeModal();
      // Form akan di-submit secara alami ke Shopify localization endpoint
    });
  }

  // Function untuk mengubah mata uang pada Apps Bucks Currency Converter
  function setBucksCurrency(targetCurrency) {
    if (!targetCurrency) return;
    const currency = targetCurrency.toUpperCase();

    // 1. Simpan langsung ke LocalStorage yang dipakai Bucks Currency Converter
    try {
      localStorage.setItem(
        'buckscc_auto_currency',
        JSON.stringify({ currency: currency, timestamp: Date.now() })
      );
      localStorage.setItem('buckscc_customer_currency', currency);
      localStorage.setItem('buckscc_currency', currency);
    } catch (err) {
      console.warn('Could not write to localStorage for Bucks:', err);
    }

    // Simpan juga ke document.cookie sebagai fallback Bucks
    try {
      document.cookie = `buckscc_currency=${currency};path=/;max-age=2592000`;
      document.cookie = `buckscc_auto_currency=${currency};path=/;max-age=2592000`;
    } catch (err) { }

    // 2. Coba klik opsi di list dropdown Bucks (.buckscc-select-options li[rel="..."])
    const bucksOption = document.querySelector(`.buckscc-select-options li.converterTriggers[rel="${currency}"]`);
    if (bucksOption) {
      bucksOption.click();
      return;
    }

    // 3. Coba ubah value di elemen <select id="bucksSelector">
    const bucksSelect = document.getElementById('bucksSelector');
    if (bucksSelect) {
      bucksSelect.value = currency;
      bucksSelect.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    // 4. Fallback jika script Bucks menyediakan global API atau event
    if (window.bucksCC && typeof window.bucksCC.changeCurrency === 'function') {
      window.bucksCC.changeCurrency(currency);
    }
  }

  // Expose ke window agar bisa dipanggil dari mana saja
  window.setBucksCurrency = setBucksCurrency;

  // Cek parameter ?currency= dari URL saat halaman dimuat, lalu sinkronkan ke Bucks App
  const urlParams = new URLSearchParams(window.location.search);
  const paramCurrency = urlParams.get('currency');
  if (paramCurrency) {
    // Karena widget Bucks dimuat secara async, kita cek dengan interval retry hingga widget siap
    let attempts = 0;
    const maxAttempts = 20; // 20 x 250ms = 5 detik
    const checkBucksInterval = setInterval(() => {
      attempts++;
      const select = document.getElementById('bucksSelector');
      const option = document.querySelector(`.buckscc-select-options li.converterTriggers[rel="${paramCurrency.toUpperCase()}"]`);

      if (select || option || (window.bucksCC && typeof window.bucksCC.changeCurrency === 'function')) {
        setBucksCurrency(paramCurrency);
        clearInterval(checkBucksInterval);
      } else if (attempts >= maxAttempts) {
        clearInterval(checkBucksInterval);
      }
    }, 250);
  }

  // Expose global trigger for opening modal from header or footer
  window.openLocalizationModal = openModal;
});
